import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { logoIcon, mainLaptopLeftImage } from 'assets/images';

import styles from './styles.module.scss';

export const InfoVideoCall = memo(() => {
  const { t } = useTranslation('welcome');

  const infoRadioButtons = [
    {
      id: 1,
      text: t('Vide_call_radio_button_1_'),
    },
    {
      id: 2,
      text: t('Vide_call_radio_button_2_'),
    },
    {
      id: 3,
      text: t('Vide_call_radio_button_3_'),
    },
  ];

  return (
    <div className={styles.info_container}>
      <div className={styles.info_title_container}>
        <span>100+</span>
        <p>{t('Video_call_li_4_')}</p>
      </div>

      <div className={styles.info_content}>
        <img
          alt=""
          src={mainLaptopLeftImage}
          loading="lazy"
        />
        <div className={styles.info_content_right}>
          <div className={styles.info_content_right_title}>
            <span>{t('Video_call_info_title_')}</span>
            <p>{t('Video_call_info_')}</p>
          </div>

          <div className={styles.infoRadioButtons_container}>
            {infoRadioButtons.map(({ id, text }) => (
              <div
                key={id}
                className={styles.radio_button}
              >
                <img
                  alt=""
                  src={logoIcon}
                  loading="lazy"
                />
                <p>{text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
});
